import * as React from "react"
import { GatsbyImage } from "gatsby-plugin-image" 

class ImageCursor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hover:false
    };
  } 
  render() { 
    return (
    	<div className="image-card--hover" data-view={this.props.view} data-current="1">
      	<div className="image--container ratio-2-1 pos-rel overflow-hidden">
      		  <div className="hover--image bg-image--container active" data-image="1">
      			  <GatsbyImage image={this.props.approach} alt="Hover Image" className="bg-image" />
        		</div> 
        		<div className="hover--image bg-image--container" data-image="2">
      			  <GatsbyImage image={this.props.folio} alt="Hover Image" className="bg-image" />
        		</div> 
        		<div className="hover--image bg-image--container" data-image="3">
      			  <GatsbyImage image={this.props.films} alt="Hover Image" className="bg-image" />
        		</div> 
        		<div className="hover--image bg-image--container" data-image="4">
              <GatsbyImage image={this.props.about} alt="Hover Image" className="bg-image" />
        		</div> 
        		<div className="hover--image bg-image--container" data-image="5">
              <GatsbyImage image={this.props.store} alt="Hover Image" className="bg-image" />
        		</div> 
            <div className="hover--image bg-image--container" data-image="6">
                <GatsbyImage image={this.props.contact} alt="Hover Image" className="bg-image" />
            </div> 
      	</div>
    	</div>
    )
  }
}

export default ImageCursor
